import { createAction } from 'redux-actions';
import { SeatMapPassenger } from '../types';

export const setPassengers = createAction<SeatMapPassenger[]>('SET_PASSENGERS');

export type SetPassengersAction = ReturnType<typeof setPassengers>;
